<template>
  <div class="community-activity app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>活动名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入活动名称" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>活动类型</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.type" placeholder="请选择活动类型">
              <a-select-option :value="1">活动报名</a-select-option>
              <a-select-option :value="2">问卷调查</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>活动状态</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.activityStatus" placeholder="请选择活动状态">
              <a-select-option :value="1">{{activityStatusText(1)}}</a-select-option>
              <a-select-option :value="2">{{activityStatusText(2)}}</a-select-option>
              <a-select-option :value="3">{{activityStatusText(3)}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>上线状态</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.status" placeholder="请选择上线状态">
              <a-select-option :value="1">上线</a-select-option>
              <a-select-option :value="0">下线</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]" v-if="isPlatformRole">
          <a-col>
            <p>发布社区</p>
          </a-col>
          <a-col>
            <a-select class="app-block" v-model="table.search.community" placeholder="请选择发布社区" allow-clear>
              <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-dropdown>
          <a-button type="primary">新增</a-button>
          <a-menu slot="overlay">
            <a-menu-item @click="newActivity()">活动报名</a-menu-item>
            <a-menu-item @click="newQuestionnaire()">问卷调查</a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange" v-viewer>
      <template slot="images" slot-scope="text, data">
        <dy-image :src="data.banner"></dy-image>
      </template>
      <template slot="show" slot-scope="text, data">
        <a-tag color="green" v-if="data.is_show">上线</a-tag>
        <a-tag v-else>下线</a-tag>
      </template>
      <template slot="action" slot-scope="text, data">
        <a-space>
          <template v-if="(!isPlatformRole && data.generate_source === 'platform') || (isPlatformRole && data.generate_source === 'community')">
            <template v-if="data.type === 'activities'">
              <a-button type="link" @mouseover="handleList(data)" v-if="!data.list.length">报名管理</a-button>
              <a-dropdown v-else>
                <a-button type="link">报名管理</a-button>
                <a-menu slot="overlay">
                  <a-menu-item v-for="(value, index) in data.list" :key="index" @click="activitySignUpManage(value)">{{value.communityName}}</a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
            <template v-if="data.type === 'topics' && data.data_status !== 1">
              <a-button type="link" @mouseover="handleList(data)" v-if="!data.list.length">回收数据</a-button>
              <a-dropdown v-else>
                <a-button type="link">回收数据</a-button>
                <a-menu slot="overlay">
                  <a-menu-item v-for="(value, index) in data.list" :key="index" @click="questionnaireRecoverData(value)">{{value.communityName}}</a-menu-item>
                </a-menu>
              </a-dropdown>
              <a-button type="link" @mouseover="handleList(data)" v-if="!data.list.length">数据统计</a-button>
              <a-dropdown v-else>
                <a-button type="link">数据统计</a-button>
                <a-menu slot="overlay">
                  <a-menu-item v-for="(value, index) in data.list" :key="index" @click="questionnaireDataStatistics(value)">{{value.communityName}}</a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
            <a-button type="link" @click="scanData(data)">查看</a-button>
          </template>
          <template v-else>
            <template v-if="data.type === 'activities'">
              <a-button type="link" @mouseover="handleList(data)" v-if="!data.list.length">报名管理</a-button>
              <a-dropdown v-else>
                <a-button type="link">报名管理</a-button>
                <a-menu slot="overlay">
                  <a-menu-item v-for="(value, index) in data.list" :key="index" @click="activitySignUpManage(value)">{{value.communityName}}</a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
            <template v-if="data.type === 'topics' && data.data_status !== 1">
              <a-button type="link" @mouseover="handleList(data)" v-if="!data.list.length">回收数据</a-button>
              <a-dropdown v-else>
                <a-button type="link">回收数据</a-button>
                <a-menu slot="overlay">
                  <a-menu-item v-for="(value, index) in data.list" :key="index" @click="questionnaireRecoverData(value)">{{value.communityName}}</a-menu-item>
                </a-menu>
              </a-dropdown>
              <a-button type="link" @mouseover="handleList(data)" v-if="!data.list.length">数据统计</a-button>
              <a-dropdown v-else>
                <a-button type="link">数据统计</a-button>
                <a-menu slot="overlay">
                  <a-menu-item v-for="(value, index) in data.list" :key="index" @click="questionnaireDataStatistics(value)">{{value.communityName}}</a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
            <a-button type="link" @click="scanData(data)">查看</a-button>
            <a-button type="link" @click="editData(data)" :disabled="!!data.is_show || !!data.status">编辑</a-button>
            <a-button type="link" @click="deleteData(data)">删除</a-button>
            <a-button type="link" @click="pushData(data)" :disabled="!!data.status || !data.is_show">推送</a-button>
            <a-button type="link" @click="switchStatusData(data)" v-if="!data.is_show">上线</a-button>
            <a-button type="link" @click="switchStatusData(data)" v-else>下线</a-button>
          </template>
        </a-space>
      </template>
    </a-table>
    <a-drawer width="80%" :title="drawer.title" :visible="drawer.show" destroy-on-close @close="drawer.show = false">
      <activity-info :id="drawer.id" is-scan v-if="drawer.type === 'activities'"></activity-info>
      <questionnaire-info :id="drawer.id" is-scan v-else></questionnaire-info>
    </a-drawer>
  </div>
</template>
<script>
  import { 
    activityStatusText 
  } from '@/io/dict.js';
  import CommunityService from '@/io/community.js';
  import CommunityActivityService from '@/io/community_activity.js';
  import ActivityService from '@/io/activity.js';
  import QuestionnaireService from '@/io/questionnaire.js';
  import ActivityInfo from '@/views/community/ActivityInfo.vue';
  import QuestionnaireInfo from '@/views/community/QuestionnaireInfo.vue';

  export default {
    name: 'CommunityActivity',
    data() {
      let self = this;
      return {
        activityStatusText,
        communityOptions: [],
        table: {
          loading: false,
          search: {
            name: null,
            type: [],
            activityStatus: [],
            status: [],
            community: [],
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            },
          },
          data: [],
          columns: [
            {
              title: '活动名称',
              dataIndex: 'title',
            },
            {
              title: '活动封面',
              scopedSlots: { customRender: 'images' },
            },
            {
              title: '活动时间',
              dataIndex: 'time',
            },
            {
              title: '活动类型',
              dataIndex: 'typeText'
            },
            {
              title: '活动状态',
              dataIndex: 'activityStatusText'
            },
            {
              title: "来源",
              dataIndex: 'sourceText'
            },
            {
              title: '是否上线',
              scopedSlots: { customRender: 'show' },
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            },
          ],
        },
        drawer: {
          id: null,
          type: null,
          title: null,
          show: false
        }
      }
    },
    components: {
      ActivityInfo,
      QuestionnaireInfo
    },
    activated() {
      this.initCommunity().then(() => {
        this.initData();
      });
    },
    methods: {
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      handleList(data) {
        (data.type === 'activities' ? ActivityService : QuestionnaireService).listIds(data.id).then(res => {
          data.list = res.map(val => {
            val.communityName = this.communityOptions.filter(m => m.id === val.community_id)[0].name;
            return val;
          });
        });
      },
      activitySignUpManage(data) {
        this.$router.push({
          name: 'ActivitySignUpManage',
          params: {
            id: data.id
          }
        });
      },
      questionnaireRecoverData(data) {
        this.$router.push({
          name: 'QuestionnaireRecoverData',
          params: {
            id: data.id
          }
        });
      },
      questionnaireDataStatistics(data) {
        this.$router.push({
          name: 'QuestionnaireDataStatistics',
          params: {
            id: data.id
          }
        });
      },
      scanData(data) {
        this.drawer.id = data.id;
        this.drawer.type = data.type;
        this.drawer.title = data.type === 'activities' ? '活动详情' : '问卷详情';
        this.drawer.show = true;
      },
      editData(data) {
        if (data.type === 'activities') {
          this.$router.push({
            name: 'EditActivity',
            params: {
              id: data.id
            }
          });
        } else {
          this.$router.push({
            name: 'EditQuestionnaire',
            params: {
              id: data.id
            }
          });
        }
      },
      deleteData(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此活动？',
          onOk() {
            (data.type === 'activities' ? ActivityService : QuestionnaireService).del([data.id]).then((res) => {
              self.initData();
            }).catch((err) => {});
          }
        });
      },
      pushData(data) {
        (data.type === 'activities' ? ActivityService : QuestionnaireService).push(data.id).then(res => {
          this.initData();
        }).catch(err => {});
      },
      switchStatusData(data) {
        (data.type === 'activities' ? ActivityService : QuestionnaireService).switchStatus(data.id).then(res => {
          this.initData();
        }).catch(err => {});
      },
      newActivity() {
        this.table.page.current = 1;
        this.$router.push({
          name: 'NewActivity'
        });
      },
      newQuestionnaire() {
        this.table.page.current = 1;
        this.$router.push({
          name: 'NewQuestionnaire'
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          type: [],
          activityStatus: [],
          status: [],
          community: [],
        };
        this.searchTable();
      },
      initCommunity() {
        return CommunityService.listPage().then((res) => {
          this.communityOptions = res;
        }).catch((err) => {});
      },
      initData() {
        this.table.loading = true;
        CommunityActivityService.listPage(
          this.table.search.name,
          this.table.search.type,
          this.table.search.activityStatus,
          this.table.search.status,
          this.table.search.community,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            if (val.generate_source === 'platform') {
              val.sourceText = '平台';
            } else {
              this.communityOptions.forEach(m => {
                if (m.id === val.community_id) {
                  val.sourceText = m.name;
                }
              });
            }
            val.time = `${val.start_time} - ${val.end_time}`;
            val.typeText = val.type === 'activities' ? '活动报名' : '问卷调查';
            val.activityStatusText = activityStatusText(val.data_status);
            val.list = [];
            return val;
          });
          this.table.page.total = res.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    }
  }
</script>

<style lang="less" scoped>

</style>